let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let last_char = "\xFF"; //when sorting stings, this is the last one

let groupBySids = function (items) {
  let by_sid = {};
  _.each(items, function (item) {
    let sids = _.size(item.sids) > 0 ? item.sids : ["-no-sids-"];
    _.each(sids, function (sid) {
      if (!_.has(by_sid, sid)) {
        by_sid[sid] = [];
      }
      by_sid[sid].push(item);
    });
  });
  return by_sid;
};

let MenuItem = dd.createClass({
  __clickItem(fn) {
    return !_.isFunction(fn) ? null : esUtils.wrapPreventDefault(fn);
  },
  render() {
    let { item, speaker_name } = this.props;
    // if (!_.includes(AuthedUserSession.companyIdsICanRead, _.get(item, "cmpid"))) {
    //   console.log("alien");
    // }
    return dd.li(
      { role: "presentation" },
      dd[item.onClick ? "a" : "span"](
        {
          role: "menuitem",
          tabIndex: "-1",
          className:
            (item.className || "") + (speaker_name ? " has-speaker-name" : ""),
          href: item.onClick ? "#" : null,
          onClick: item.onClick ? this.__clickItem(item.onClick) : null,
        },
        speaker_name
          ? dd.b(
              {
                className: "speaker-name",
              },
              speaker_name
            )
          : null,
        item.icon ? item.icon : null,
        dd.span({ className: "item-name" }, item.name)
      )
    );
  },
});

let speakerAbbreviatedName = function (spkr) {
  if (AuthedUserSession.is_st_family) {
    if (
      !_.isEmpty(_.get(spkr, "name_first")) &&
      !_.isEmpty(_.get(spkr, "name_last"))
    ) {
      return (
        _.get(spkr, "name_last") +
        ", " +
        _.get(spkr, "name_first").substring(0, 1)
      );
    }
    return _.get(spkr, "name_full");
  } else {
    if (
      !_.isEmpty(_.get(spkr, "name_first")) &&
      !_.isEmpty(_.get(spkr, "name_last"))
    ) {
      return _.get(spkr, "name_first") + " " + _.get(spkr, "name_last");
    }
    return _.get(spkr, "name_full");
  }
};

let getAbbreviatedNamesBySid = function (Displaylists) {
  return _.object(
    _.compact(
      _.map(Displaylists && Displaylists.perspeaker, function (spkr) {
        let name = speakerAbbreviatedName(spkr);
        return _.isEmpty(name) ? null : [spkr.sid, name];
      })
    )
  );
};

module.exports = dd.createClass({
  getInitialState() {
    return { popover_top: 0, popover_left: 0 };
  },
  componentDidMount() {
    this.__setup_position();
  },
  componentDidUpdate() {
    this.__setup_position();
  },
  __setup_position() {
    let dom_node = this.refs.popover;
    if (!dom_node) {
      return;
    }
    let width_factor = _.isNumber(this.props.width_factor)
      ? this.props.width_factor
      : 0.75;
    let height_factor = _.isNumber(this.props.height_factor)
      ? this.props.height_factor
      : 0.5;

    let parentNode = dom_node.parentNode;
    let rect = parentNode.getBoundingClientRect();
    let parent_width = Math.max(0, parentNode.offsetWidth);
    let parent_height = Math.max(0, parentNode.offsetHeight);
    let h = Math.max(0, dom_node.offsetHeight);
    let top = rect.top - h / 2 + parent_height * height_factor + "px";
    let left = rect.left + parent_width * width_factor + "px";
    if (top !== this.state.popover_top || left !== this.state.popover_left) {
      this.setState({ popover_top: top, popover_left: left }); //only make changes when needed so we don't get into a loop
    }
  },
  __onScroll: esUtils.wrapPreventDefault(function (e) {
    e.stopPropagation();
  }),
  render() {
    let { items, Displaylists, is_multi_sid_mode, empire_mode } = this.props;
    let items_by_sid = groupBySids(items);
    let spkrname_by_sid = getAbbreviatedNamesBySid(Displaylists);

    let menu_items = _.flatten(
      _.map(
        items_by_sid,
        function (items, sid) {
          let speaker_name =
            is_multi_sid_mode || empire_mode ? spkrname_by_sid[sid] : null;
          return _.map(
            items,
            function (item, i) {
              return {
                elm: MenuItem({
                  key: sid + "-" + i,
                  item,
                  speaker_name,
                  empire_mode,
                }),
                sort_key:
                  sid === "-no-sids-"
                    ? last_char + last_char + last_char
                    : (speaker_name || last_char) + item.name,
              };
            },
            this
          );
        },
        this
      )
    );

    return dd.div(
      {
        className: "DayPopover popover right",
        ref: "popover",
        style: {
          position: "fixed",
          display: "block",
          top: this.state.popover_top,
          left: this.state.popover_left,
          bottom: "auto",
          right: "auto",
          maxWidth: "none",

          //normalizing styles (so parent font styling doesn't mess with this)
          fontSize: 14,
          color: "black",
          textAlign: "left",
          fontWeight: "normal",
        },
      },
      dd.div({ className: "arrow" }),
      dd.ul(
        { className: "dropdown-menu", role: "menu", onScroll: this.__onScroll },
        _.map(
          _.sortBy(menu_items, function ({ sort_key }) {
            return sort_key.trim().toLowerCase();
          }),
          "elm"
        )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/DayPopover.js